var map = {
	"./2-3porte.svg": "e93a",
	"./4-5porte.svg": "c1a6",
	"./camper.svg": "4ff0",
	"./coupe.svg": "044b",
	"./fuoristrada.svg": "f6eb",
	"./monovolume.svg": "6ae3",
	"./moto.svg": "92c4",
	"./station-wagon.svg": "676c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e38";